import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

// app modules: actions
import { pinPage, unpinPage } from 'actions/pinnedPages';

import route from 'services/route';

import Icon from 'components/Icon';

import {COLOURS} from "../../constants";

function PinRecipeItem(props) {
  const {
    component: ItemComponent,
    contentType,
    iconClassName,
    itemId,
    onClick,
    page,
    ...others
  } = props;
  const dispatch = useDispatch();
  const pinnedPages = useSelector(state => state.pinnedPages);

  const generatedPathname = useMemo(() => route.content(page.id, page.title), [page]);
  const foundPathname = useMemo(() => {
    const idInGeneratedPathname = generatedPathname.split('/')[2]
    const found = Object.keys(pinnedPages).find(key => {
      const idInPath = key.split('/')[2]

      return idInGeneratedPathname === idInPath
    });

    if (found) {
      return found;
    }
    return null;
  }, [pinnedPages, generatedPathname]);

  const isPinned = useMemo(() => !!pinnedPages[foundPathname], [foundPathname, pinnedPages]);

  const pinIconName = useMemo(() => `push-pin${isPinned ? '-filled' : ''}`, [isPinned]);

  const pinButtonTitle = useMemo(() => `${isPinned ? 'Unpin' : 'Pin'} this ${contentType}`, [isPinned, contentType]);

  const handlePinPage = () => {
    dispatch(pinPage({pathname: generatedPathname, ...page}));
    onClick();
  };

  const handleUnpinPage = () => {
    dispatch(unpinPage(foundPathname));
    onClick();
  };

  const handleButtonClick = () => {
    if (isPinned) {
      handleUnpinPage();
    } else {
      handlePinPage();
    }
  }

  return (
    <ItemComponent onClick={handleButtonClick} {...others}>
      <ListItemIcon className={iconClassName}>
        <Icon fill={COLOURS.ENERGIZED} name={pinIconName} height="40" width="40" />
      </ListItemIcon>
      <ListItemText>{pinButtonTitle}</ListItemText>
    </ItemComponent>
  );
}

PinRecipeItem.propTypes = {
  className: PropTypes.string,
  component: PropTypes.elementType,
  iconClassName: PropTypes.string,
  itemId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  page: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    book: PropTypes.shape({
      image_name: PropTypes.string,
    }),
    primary_image: PropTypes.shape({
      crops: PropTypes.arrayOf(
        PropTypes.shape({
          sizes: PropTypes.arrayOf(
            PropTypes.shape({
              src: PropTypes.string,
            }),
          ),
        }),
      ),
    }),
  }),
};

PinRecipeItem.defaultProps = {
  className: null,
  component: ListItem,
  iconClassName: null,
  page: {},
  onClick: () => {},
};

export default PinRecipeItem;
